<template>
    <div class="dark-sidenav">
        <confirm-dialog></confirm-dialog>
        <loader :show="!!waiting"></loader>

        <div
            v-if="application_unlocked"
            :class="{'navigating': !!navigating}"
            class="app"
        >
            <section
                id="nibnut-side-navigation"
                class="app-navigation"
            >
                <div class="branding">
                    <router-link to="/" exact>
                        <img v-if="setting('application_logo')" :src="setting('application_logo')" :alt="setting('application_name')">
                        <span v-else>{{ $root.application_name }}</span>
                    </router-link>
                    <div v-if="app_version" class="app-version-indicator mt-1">({{ app_version }})</div>
                </div>
                <nav>
                    <nav-menu v-if="!!profile_id" position="left"></nav-menu>
                </nav>
                <div class="copyright">
                    <small>&copy; {{ current_year }} {{ $root.customer_name }}</small>
                    <br>
                    <small>
                        <a href="https://nibnut.com" target="_blank" title="This app was grown using only free-range electrons">{{ $root.translate("App sprouted from a") }} nibnut</a>
                    </small>
                </div>
            </section>
            <section v-if="!!profile_id" class="app-content">
                <router-view
                    id="nibnut-app-content"
                    @toggle-navigation="toggle_navigation"
                ></router-view>
            </section>
        </div>

        <login id="login-dialog" :show="!profile_id && !waiting && !guest_screen"></login>
        <reset-password id="reset-password-dialog" :show="(!profile_id && !waiting && (guest_screen==='password-reset'))" v-on:password-reset="clear_guest_screen"></reset-password>
        <system-message
            v-if="!!system_message.message"
            :message="system_message"
            :countdown="message_countdown"
            @click="dismiss_message"
        />
    </div>
</template>

<script type="text/javascript">
import { mapState } from "vuex"

import utilities from "./mixins/Is"

import { Loader } from "./library"
import SystemMessage from "./ui/SystemMessage"
import NavMenu from "./ui/NavMenu.vue"

import ConfirmDialog from "./dialogs/ConfirmDialog.vue"
import Login from "./dialogs/Login.vue"
import ResetPassword from "./dialogs/ResetPassword.vue"

const moment = require("moment")

let timer = null

export default {
    mounted () {
        if(!this.profile_id) this.loadProfile()
        else this.next_guest_screen()
    },
    components: {
        Loader,
        SystemMessage,
        ConfirmDialog,
        NavMenu,
        Login,
        ResetPassword
    },
    mixins: [utilities],
    watch: {
        profile_id: "profile_changed",
        "system_message.message": "system_message_changed"
    },
    methods: {
        toggle_navigation () {
            this.navigating = !this.navigating
        },
        profile_changed () {
            this.next_guest_screen()
        },
        next_guest_screen () {
            if(!!window.location.search && !!window.location.search.match(/(\?|&)password-reset=/i) && (!this.profile || !this.profile.id)) this.guest_screen = "password-reset"
            else this.guest_screen = ""
        },
        clear_guest_screen () {
            this.guest_screen = ""
        },
        loadProfile () {
            this.$store.dispatch("LOAD_PROFILE").then(() => {
                this.next_guest_screen()
            })
        },
        system_message_changed () {
            if(timer) {
                clearInterval(timer)
                timer = null
            }
            if(this.system_message.message) {
                this.message_countdown = this.system_message.dismiss_after || 7000
                const step = 10
                timer = setInterval(() => {
                    this.message_countdown -= step
                    if(this.message_countdown <= 0) {
                        clearInterval(timer)
                        timer = null
                        this.dismiss_message()
                    }
                }, step)
            }
        },
        dismiss_message (event) {
            const system_message = this.system_message
            const system_message_id = system_message ? system_message.message_id : null
            this.$store.dispatch("SYSTEM_MESSAGE", {
                type: "warning",
                message: "",
                dismiss_after: 0,
                message_id: null
            })
            if(!!system_message_id && (system_message_id === "update-app")) {
                this.update_app()
            }
        }
    },
    computed: {
        ...mapState(["waiting", "system_message"]),
        application_unlocked () {
            return !!this.profile && !this.guest_screen
        },
        current_year () {
            return moment().format("YYYY")
        },
        padding_top () {
            if(!this.$refs.navigation && !this.navigation_height) return false
            if(this.$refs.navigation) return this.$refs.navigation.clientHeight + "px"
            return this.navigation_height + "px"
        },
        padding_bottom () {
            if(!this.$refs.footer && !this.footer_height) return false
            if(this.$refs.footer) return this.$refs.footer.clientHeight + "px"
            return this.footer_height + "px"
        }
    },
    data () {
        return {
            navigation_height: 0,
            footer_height: 0,
            guest_screen: "",
            navigating: true,
            message_countdown: 0
        }
    }
}
</script>
